import { useState } from "react";
import { Reveal } from "@/components/shared/Reveal";
import { ConstellationField, CelestialRing, Sparkle } from "@/components/shared/Motifs";
import { LanguageToggle } from "@/components/shared/LanguageToggle";
import { PhoneFrame, ReportContent } from "@/components/report/DailyReport";
import { useLanguage } from "@/context/LanguageContext";
import { CONTENT } from "@/i18n/content";
import { REPORTS } from "@/data/reports";

export function SampleReport() {
  const { lang } = useLanguage();
  const t = CONTENT[lang].sample;
  // Independent local language for the preview (initialized from global).
  const [previewLang, setPreviewLang] = useState(lang);
  const report = REPORTS[previewLang];

  return (
    <section id="sample" className="relative scroll-mt-20 overflow-hidden bg-navy-dark py-20 sm:py-28" data-testid="sample-report">
      <ConstellationField className="pointer-events-none absolute inset-0 h-full w-full text-gold/[0.07]" />
      <div className="pointer-events-none absolute left-1/2 top-10 h-72 w-72 -translate-x-1/2 rounded-full bg-gold/10 blur-3xl" />

      <div className="relative mx-auto max-w-3xl px-5 text-center sm:px-8">
        <Reveal>
          <div className="mb-3 flex items-center justify-center gap-2">
            <span className="h-px w-6 bg-gold" />
            <span className="text-xs font-semibold uppercase tracking-[0.2em] text-gold">{t.eyebrow}</span>
            <span className="h-px w-6 bg-gold" />
          </div>
          <h2 className="font-heading text-3xl font-semibold leading-tight text-cream sm:text-4xl lg:text-5xl text-balance">
            {t.title}
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-sm leading-relaxed text-cream/70 sm:text-base">{t.sub}</p>
        </Reveal>

        <Reveal delay={120} className="mt-8 flex justify-center">
          <LanguageToggle
            value={previewLang}
            onChange={setPreviewLang}
            testIdPrefix="sample-lang"
            className="border-cream/20 bg-white"
          />
        </Reveal>
      </div>

      <Reveal delay={150} className="mx-auto mt-6 flex max-w-md items-center justify-center gap-2 px-5 text-center">
        <Sparkle size={12} className="shrink-0 text-gold" />
        <p className="text-xs font-medium text-cream/60">{t.note}</p>
      </Reveal>

      <Reveal delay={180} className="relative mt-8 flex justify-center px-5">
        <div className="relative">
          <div className="pointer-events-none absolute left-1/2 top-1/2 h-[560px] w-[560px] -translate-x-1/2 -translate-y-1/2">
            <CelestialRing className="h-full w-full text-gold/25 animate-spin-slow-rev" />
          </div>
          <PhoneFrame className="relative">
            <ReportContent report={report} />
          </PhoneFrame>
        </div>
      </Reveal>
    </section>
  );
}
